import { Suspense, lazy, useMemo } from "react";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { jsx } from "react/jsx-runtime";
//#region src/use-course-trial.tsx
var LazyCourseTrial = lazy(() => import("./course-trial-CCQ1Humu.js").then((n) => n.r).then((module) => ({ default: module.CourseTrial })));
function CourseTrial({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-trial" }),
		children: /* @__PURE__ */ jsx(LazyCourseTrial, { ...props })
	});
}
function CourseTrialContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-trial" }),
		children: /* @__PURE__ */ jsx(LazyCourseTrial, { ...props })
	});
}
var useCourseTrialContent = () => {
	return useMemo(() => ({ courseTrial: { component: CourseTrialContent } }), []);
};
//#endregion
export { useCourseTrialContent as n, CourseTrial as t };
